import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSgmTag = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Tag_-_SGM",
	"data-name": "Tag - SGM",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 51.627 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_1283",
		"data-name": "Group 1283",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4262",
				"data-name": "Path 4262",
				d: "M108.679,45.123H96.773V42.847h11.906a8.5,8.5,0,0,0,8.294-8.675V29.353h2.277v4.819a10.779,10.779,0,0,1-10.57,10.951",
				transform: "translate(-69.7 -21.141)",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4263",
				"data-name": "Path 4263",
				d: "M13.277,29.333H10.57A10.778,10.778,0,0,1,0,18.382,10.779,10.779,0,0,1,10.57,7.43H43.482V9.706H10.57a8.5,8.5,0,0,0-8.294,8.675,8.5,8.5,0,0,0,8.294,8.675h2.706Z",
				transform: "translate(0 -5.351)",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4264",
				"data-name": "Path 4264",
				d: "M22.955,35.386a4.114,4.114,0,0,0,2.679.967c.7,0,1.249-.343,1.249-.826,0-1.47-4.734-.947-4.734-4.089,0-1.874,1.813-3.042,3.747-3.042a6.061,6.061,0,0,1,3.3.987l-1.229,1.894a3.294,3.294,0,0,0-1.874-.665c-.725,0-1.329.282-1.329.786,0,1.269,4.734.765,4.734,4.15,0,1.873-1.833,3.022-3.888,3.022a6.759,6.759,0,0,1-3.928-1.309Z",
				transform: "translate(-15.619 -20.452)",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4265",
				"data-name": "Path 4265",
				d: "M97.105,38.367V28.6h2.518v.786a3.885,3.885,0,0,1,2.639-.987,4.259,4.259,0,0,1,3.283,1.531A4.85,4.85,0,0,1,109.01,28.4a4.455,4.455,0,0,1,3.424,1.572,4.848,4.848,0,0,1,.987,3.223v5.177H110.8V33.089a2.3,2.3,0,0,0-.484-1.672,1.96,1.96,0,0,0-1.47-.6,3.05,3.05,0,0,0-2.357,1.289,8.588,8.588,0,0,1,.081,1.088v5.177h-2.619V33.089a2.3,2.3,0,0,0-.483-1.672,1.961,1.961,0,0,0-1.47-.6,3.017,3.017,0,0,0-2.276,1.209v6.345Z",
				transform: "translate(-69.94 -20.451)",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4266",
				"data-name": "Path 4266",
				d: "M62.927,28.6H60.41v.786a4.478,4.478,0,0,0-2.86-.987,4.9,4.9,0,0,0-4.794,5.1,5.228,5.228,0,0,0,1.229,3.425,4.956,4.956,0,0,0,3.706,1.652,4.12,4.12,0,0,0,2.619-.886V38c0,.129,0,1.3-.008,1.411h.011a2.8,2.8,0,0,1-.6,1.934,2.521,2.521,0,0,1-1.994.786,3.95,3.95,0,0,1-3.042-1.41l-1.652,1.712a6.41,6.41,0,0,0,4.693,2.015A5.2,5.2,0,0,0,62.053,42.5a5.427,5.427,0,0,0,.875-3.082h-.011c.007-.174.011-1.4.011-1.593Zm-2.618,6.345a2.86,2.86,0,0,1-2.357,1.209,2.672,2.672,0,0,1-.06-5.338,3,3,0,0,1,2.417,1.209Z",
				transform: "translate(-37.997 -20.452)",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_540",
				"data-name": "Rectangle 540",
				width: 6.821,
				height: 2.276,
				transform: "translate(45.194 4.823) rotate(-45)",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_541",
				"data-name": "Rectangle 541",
				width: 2.276,
				height: 6.821,
				transform: "matrix(0.707, -0.707, 0.707, 0.707, 45.194, 1.61)",
				fill: "currentColor"
			})
		]
	})
});
export { SvgSgmTag as ReactComponent };
